type Map<T> = { [key: string]: T };

export type Event =
  | 'account created'
  | 'account logged in'
  | 'add signable document clicked'
  | 'banner selected'
  | 'banner upload attempted'
  | 'bulk approved references'
  | 'bulk approved synced content'
  | 'bulk rejected references'
  | 'bulk rejected synced content'
  | 'bulk synced on-demand'
  | 'buyer copilot toggled'
  | 'chat visibility toggled'
  | 'chrome extension clicked'
  | 'collaborators updated'
  | 'company created'
  | 'company profile settings saved'
  | 'company search submitted'
  | 'configure chat clicked'
  | 'consent accepted'
  | 'consent rejected'
  | 'consent viewed'
  | 'contact created'
  | 'DSR - Chat Consent Closed'
  | 'DSR - Consent Accepted'
  | 'DSR - Consent Viewed'
  | 'contact edited'
  | 'contact name edited'
  | 'contact reply posted'
  | 'contact requested'
  | 'contact search submitted'
  | 'contacts bulk added via paste'
  | 'content attribute created'
  | 'content attribute edited'
  | 'content created'
  | 'content details edited'
  | 'content downloaded'
  | 'content link created'
  | 'content link room copied'
  | 'content link viewed'
  | 'content preview failed'
  | 'content previewed'
  | 'content updated'
  | 'conversation drawer opened'
  | 'crm connected'
  | 'crm disconnected'
  | 'crm edited'
  | 'crm sync clicked'
  | 'crm sync failed'
  | 'deal created'
  | 'deal edited'
  | 'deal room access granted'
  | 'deal room created'
  | 'deal room edited'
  | 'deal room email denied'
  | 'deal room email provided'
  | 'deal room email requested'
  | 'deal room link copied'
  | 'deal room link inserted'
  | 'deal room question asked'
  | 'deal room session statistics viewed'
  | 'deal room shared'
  | 'deal room started'
  | 'deal room statistics viewed'
  | 'deal room view attempted'
  | 'deal room viewed'
  | 'deal search submitted'
  | 'DSR - Add Content Clicked'
  | 'DSR - Add Content - File Source Clicked'
  | 'DSR - Add Content - Files Selected'
  | 'DSR - Add Content - Record Clicked'
  | 'DSR - Add Content - Recording Deleted'
  | 'DSR - Add Content - Recording Option Selected'
  | 'DSR - Add Content - Recording Stopped'
  | 'DSR - Add Content - Tab Loaded'
  | 'deals exported'
  | 'downloadable'
  | 'download controls toggled'
  | 'draft room created'
  | 'edit room started'
  | 'draft room edited'
  | 'edit a copy clicked'
  | 'edit content clicked'
  | 'existing content viewed'
  | 'icon searched'
  | 'icon uploaded'
  | 'image enlarged'
  | 'insights all content exported'
  | 'insights page viewed'
  | 'integration connected'
  | 'library filtered'
  | 'library search submitted'
  | 'link copied'
  | 'link created'
  | 'link edited'
  | 'link owner changed'
  | 'link view attempted'
  | 'link viewed'
  | 'map created'
  | 'map drawer opened'
  | 'map task contact collision resolved'
  | 'map task contact comment added'
  | 'map task contact created'
  | 'map task contact edited'
  | 'map task contact status edited'
  | 'map task user collision resolved'
  | 'map task user comment added'
  | 'map task user created'
  | 'map task user edited'
  | 'map task user status edited'
  | 'map template created'
  | 'map template edited'
  | 'organization usage exported'
  | 'page viewed'
  | 'partner sf connect clicked'
  | 'processing document viewed'
  | 'question created'
  | 'question edited'
  | 'question posted'
  | 'reference accepted'
  | 'reference category created'
  | 'reference category edited'
  | 'reference deleted'
  | 'reference request created'
  | 'reference request link copied'
  | 'reference request reminder sent'
  | 'reference request viewed'
  | 'reference requested'
  | 'reference submitted'
  | 'registration completed'
  | 'reminder cancelled'
  | 'reminder saved'
  | 'reorder content done'
  | 'reorder content entered'
  | 'room creators exported'
  | 'room customized'
  | 'room edit email sent'
  | 'room options saved'
  | 'room owner changed'
  | 'DSR - Hide Section Toggled'
  | 'room sms sent'
  | 'room template created'
  | 'room template edited'
  | 'room template link copied'
  | 'rooms exported'
  | 'rooms loaded with rolling up'
  | 'sales action clicked'
  | 'sales action created'
  | 'sales action edited'
  | 'schedule call requested'
  | 'section header created'
  | 'section header edited'
  | 'select cover image clicked'
  | 'select cover image done'
  | 'shared link statistics viewed'
  | 'signable document attached'
  | 'signable document contact downloaded'
  | 'signable document contact signed'
  | 'signable document contact viewed '
  | 'signable document edited'
  | 'signable document removed'
  | 'signable document sync clicked'
  | 'signable document user downloaded'
  | 'signable document user signed'
  | 'signable document user viewed'
  | 'signable document voided'
  | 'signable provider updated'
  | 'signer details edited'
  | 'storage provider connected'
  | 'storage provider disconnected'
  | 'storage provider updated'
  | 'subscription error dismissed'
  | 'subscription plan clicked'
  | 'subscription plans viewed'
  | 'team added'
  | 'team edited'
  | 'thumbnail selected'
  | 'trial converted'
  | 'trial end modal viewed'
  | 'upgrade modal viewed'
  | 'user invited'
  | 'user reply posted'
  | 'user view set'
  | 'users exported'
  | 'visitor stats removed'
  | 'visitors filtered'
  | 'visits exported'
  | 'welcome message overlay viewed'
  | 'DSR - Welcome Message - Saved'
  | 'DSR - Welcome Message - Modal Closed Without Save'
  | 'DSR - Buyer Copilot - Message Sent'
  | 'DSR - Buyer Copilot - Answer Copied'
  | 'DSR - Buyer Copilot - Feedback Given'
  | 'DSR - Buyer Copilot - Answer Source Clicked'
  | 'DSR - Buyer Copilot - Chat History Cleared'
  | 'DSR - Buyer Copilot Answer Generated'
  | 'DSR - Buyer Copilot Opened'
  | 'DSR - Buyer Copilot Loaded'
  | 'DSR - Folder Created'
  | 'DSR - Folder Renamed'
  | 'DSR - Folder Deleted'
  | 'DSR - Folder Opened (Room Editor)'
  | 'DSR - Folder Opened (Room Visitor)'
  | 'DSR - Folder Breadcrumb Clicked'
  | 'DSR - Room Company Selected'
  | 'dsr_asset_link_copied'
  | 'dsr_deep_link_accessed'
  | 'dsr_section_link_copied';

export const Events: Map<Event> = {
  ACCOUNT_CREATED: 'account created',
  ACCOUNT_LOGGED_IN: 'account logged in',
  ADD_SIGNABLE_DOCUMENT_CLICKED: 'add signable document clicked',
  BANNER_SELECTED: 'banner selected',
  BANNER_UPLOAD_ATTEMPTED: 'banner upload attempted',
  BULK_APPROVED_REFERENCES: 'bulk approved references',
  BULK_APPROVED_SYNCED_CONTENT: 'bulk approved synced content',
  BULK_REJECTED_REFERENCES: 'bulk rejected references',
  BULK_REJECTED_SYNCED_CONTENT: 'bulk rejected synced content',
  BULK_SYNCED_ON_DEMAND: 'bulk synced on-demand',
  BUYER_COPILOT_TOGGLED: 'buyer copilot toggled',
  CHAT_VISIBILITY_TOGGLED: 'chat visibility toggled',
  CHROME_EXTENSION_CLICKED: 'chrome extension clicked',
  COLLABORATORS_UPDATED: 'collaborators updated',
  COMPANY_CREATED: 'company created',
  COMPANY_PROFILE_SETTINGS_SAVED: 'company profile settings saved',
  COMPANY_SEARCH_SUBMITTED: 'company search submitted',
  CONFIGURE_CHAT_CLICKED: 'configure chat clicked',
  CONSENT_ACCEPTED: 'consent accepted',
  CONSENT_REJECTED: 'consent rejected',
  CONSENT_VIEWED: 'consent viewed',
  CONTACT_CREATED: 'contact created',
  DSR_CHAT_CONSENT_CLOSED: 'DSR - Chat Consent Closed',
  DSR_CONSENT_ACCEPTED: 'DSR - Consent Accepted',
  DSR_CONSENT_VIEWED: 'DSR - Consent Viewed',
  CONTACT_EDITED: 'contact edited',
  CONTACT_NAME_EDITED: 'contact name edited',
  CONTACT_REPLY_POSTED: 'contact reply posted',
  CONTACT_REQUESTED: 'contact requested',
  CONTACT_SEARCH_SUBMITTED: 'contact search submitted',
  CONTACTS_BULK_ADDED_VIA_PASTE: 'contacts bulk added via paste',
  CONTENT_ATTRIBUTE_CREATED: 'content attribute created',
  CONTENT_ATTRIBUTE_EDITED: 'content attribute edited',
  CONTENT_CREATED: 'content created',
  CONTENT_DETAILS_EDITED: 'content details edited',
  CONTENT_DOWNLOADED: 'content downloaded',
  CONTENT_LINK_COPIED: 'link copied',
  CONTENT_LINK_CREATED: 'content link created',
  CONTENT_LINK_OWNER_CHANGED: 'link owner changed',
  CONTENT_LINK_ROOM_CREATED: 'link created',
  CONTENT_LINK_ROOM_EDITED: 'link edited',
  CONTENT_LINK_ROOM_LINK_COPIED: 'content link room copied',
  CONTENT_LINK_ROOM_VIEW_ATTEMPTED: 'link view attempted',
  CONTENT_LINK_ROOM_VIEWED: 'link viewed',
  CONTENT_LINK_VIEWED: 'content link viewed',
  CONTENT_PREVIEW_FAILED: 'content preview failed',
  CONTENT_PREVIEWED: 'content previewed',
  CONTENT_UPDATED: 'content updated',
  CONVERSATION_DRAWER_OPENED: 'conversation drawer opened',
  CRM_CONNECTED: 'crm connected',
  CRM_DISCONNECTED: 'crm disconnected',
  CRM_EDITED: 'crm edited',
  CRM_SYNC_FAILED: 'crm sync failed',
  CRM_SYNC_REQUESTED: 'crm sync clicked',
  DEAL_CREATED: 'deal created',
  DEAL_EDITED: 'deal edited',
  DEAL_ROOM_ACCESS_GRANTED: 'deal room access granted',
  DEAL_ROOM_CREATED: 'deal room created',
  DEAL_ROOM_EDITED: 'deal room edited',
  DEAL_ROOM_EMAIL_DENIED: 'deal room email denied',
  DEAL_ROOM_EMAIL_PROVIDED: 'deal room email provided',
  DEAL_ROOM_EMAIL_REQUESTED: 'deal room email requested',
  DEAL_ROOM_LINK_COPIED: 'deal room link copied',
  DEAL_ROOM_LINK_INSERTED: 'deal room link inserted',
  DEAL_ROOM_QUESTION_ASKED: 'deal room question asked',
  DEAL_ROOM_SESSION_STATISTICS_VIEWED: 'deal room session statistics viewed',
  DEAL_ROOM_SHARED: 'deal room shared',
  DEAL_ROOM_STARTED: 'deal room started',
  DEAL_ROOM_STATISTICS_VIEWED: 'deal room statistics viewed',
  DEAL_ROOM_VIEW_ATTEMPTED: 'deal room view attempted',
  DEAL_ROOM_VIEWED: 'deal room viewed',
  DEAL_SEARCH_SUBMITTED: 'deal search submitted',
  DSR_ADD_CONTENT_CLICKED: 'DSR - Add Content Clicked',
  DSR_ADD_CONTENT_FILE_SOURCE_CLICKED:
    'DSR - Add Content - File Source Clicked',
  DSR_ADD_CONTENT_FILES_SELECTED: 'DSR - Add Content - Files Selected',
  DSR_ADD_CONTENT_RECORD_CLICKED: 'DSR - Add Content - Record Clicked',
  DSR_ADD_CONTENT_RECORDING_DELETED: 'DSR - Add Content - Recording Deleted',
  DSR_ADD_CONTENT_RECORDING_OPTION_SELECTED:
    'DSR - Add Content - Recording Option Selected',
  DSR_ADD_CONTENT_RECORDING_STOPPED: 'DSR - Add Content - Recording Stopped',
  DSR_ADD_CONTENT_TAB_LOADED: 'DSR - Add Content - Tab Loaded',
  DEALS_EXPORTED: 'deals exported',
  DRAFT_ROOM_CREATED: 'draft room created',
  DOWNLOAD_CONTROLS_TOGGLED: 'download controls toggled',
  EDIT_ROOM_STARTED: 'edit room started',
  DRAFT_ROOM_EDITED: 'draft room edited',
  EDIT_CONTENT_CLICKED: 'edit content clicked',
  EDIT_COPY_CLICKED: 'edit a copy clicked',
  EXISTING_CONTENT_VIEWED: 'existing content viewed',
  ICON_SEARCHED: 'icon searched',
  ICON_UPLOADED: 'icon uploaded',
  IMAGE_ENLARGED: 'image enlarged',
  INSIGHTS_ALL_CONTENT_EXPORTED: 'insights all content exported',
  INSIGHTS_PAGE_VIEWED: 'insights page viewed',
  INTEGRATION_CONNECTED: 'integration connected',
  LIBRARY_FILTERED: 'library filtered',
  LIBRARY_SEARCH_SUBMITTED: 'library search submitted',
  MAP_CREATED: 'map created',
  MAP_DRAWER_OPENED: 'map drawer opened',
  MAP_TASK_CONTACT_COLLISION_RESOLVED: 'map task contact collision resolved',
  MAP_TASK_CONTACT_COMMENT_ADDED: 'map task contact comment added',
  MAP_TASK_CONTACT_CREATED: 'map task contact created',
  MAP_TASK_CONTACT_EDITED: 'map task contact edited',
  MAP_TASK_CONTACT_STATUS_EDITED: 'map task contact status edited',
  MAP_TASK_USER_COLLISION_RESOLVED: 'map task user collision resolved',
  MAP_TASK_USER_COMMENT_ADDED: 'map task user comment added',
  MAP_TASK_USER_CREATED: 'map task user created',
  MAP_TASK_USER_EDITED: 'map task user edited',
  MAP_TASK_USER_STATUS_EDITED: 'map task user status edited',
  MAP_TEMPLATE_CREATED: 'map template created',
  MAP_TEMPLATE_EDITED: 'map template edited',
  ORGANIZATION_USAGE_EXPORTED: 'organization usage exported',
  PAGE_VIEWED: 'page viewed',
  PARTNER_SF_CONNECT_CLICKED: 'partner sf connect clicked',
  PROCESSING_DOCUMENT_VIEWED: 'processing document viewed',
  QUESTION_CREATED: 'question created',
  QUESTION_EDITED: 'question edited',
  QUESTION_POSTED: 'question posted',
  REFERENCE_ACCEPTED: 'reference accepted',
  REFERENCE_CATEGORY_CREATED: 'reference category created',
  REFERENCE_CATEGORY_EDITED: 'reference category edited',
  REFERENCE_DELETED: 'reference deleted',
  REFERENCE_REQUEST_CREATED: 'reference request created',
  REFERENCE_REQUEST_LINK_COPIED: 'reference request link copied',
  REFERENCE_REQUEST_REMINDER_SENT: 'reference request reminder sent',
  REFERENCE_REQUEST_VIEWED: 'reference request viewed',
  REFERENCE_REQUESTED: 'reference requested',
  REFERENCE_SUBMITTED: 'reference submitted',
  REGISTRATION_COMPLETED: 'registration completed',
  REMINDER_CANCELLED: 'reminder cancelled',
  REMINDER_SAVED: 'reminder saved',
  REORDER_CONTENT_DONE: 'reorder content done',
  REORDER_CONTENT_ENTERED: 'reorder content entered',
  ROOM_CREATORS_EXPORTED: 'room creators exported',
  ROOM_CUSTOMIZED: 'room customized',
  ROOM_EDIT_EMAIL_SENT: 'room edit email sent',
  ROOM_OPTIONS_SAVED: 'room options saved',
  ROOM_OWNER_CHANGED: 'room owner changed',
  DSR_HIDE_SECTION_TOGGLED: 'DSR - Hide Section Toggled',
  DSR_ROOM_COMPANY_SELECTED: 'DSR - Room Company Selected',
  DSR_ASSET_LINK_COPIED: 'dsr_asset_link_copied',
  DSR_DEEP_LINK_ACCESSED: 'dsr_deep_link_accessed',
  DSR_SECTION_LINK_COPIED: 'dsr_section_link_copied',
  ROOM_SMS_SENT: 'room sms sent',
  ROOM_TEMPLATE_CREATED: 'room template created',
  ROOM_TEMPLATE_EDITED: 'room template edited',
  ROOM_TEMPLATE_LINK_COPIED: 'room template link copied',
  ROOMS_EXPORTED: 'rooms exported',
  ROOMS_LOADED_WITH_ROLLING_UP: 'rooms loaded with rolling up',
  SALES_ACTION_CLICKED: 'sales action clicked',
  SALES_ACTION_CREATED: 'sales action created',
  SALES_ACTION_EDITED: 'sales action edited',
  SCHEDULE_CALL_REQUESTED: 'schedule call requested',
  SECTION_HEADER_CREATED: 'section header created',
  SECTION_HEADER_EDITED: 'section header edited',
  SELECT_COVER_IMAGE_CLICKED: 'select cover image clicked',
  SELECT_COVER_IMAGE_DONE: 'select cover image done',
  SHARED_LINK_STATISTICS_VIEWED: 'shared link statistics viewed',
  SIGNABLE_DOCUMENT_ATTACHED: 'signable document attached',
  SIGNABLE_DOCUMENT_CONTACT_DOWNLOADED: 'signable document contact downloaded',
  SIGNABLE_DOCUMENT_CONTACT_SIGNED: 'signable document contact signed',
  SIGNABLE_DOCUMENT_CONTACT_VIEWED: 'signable document contact viewed ',
  SIGNABLE_DOCUMENT_EDITED: 'signable document edited',
  SIGNABLE_DOCUMENT_REMOVED: 'signable document removed',
  SIGNABLE_DOCUMENT_SYNC_CLICKED: 'signable document sync clicked',
  SIGNABLE_DOCUMENT_USER_DOWNLOADED: 'signable document user downloaded',
  SIGNABLE_DOCUMENT_USER_SIGNED: 'signable document user signed',
  SIGNABLE_DOCUMENT_USER_VIEWED: 'signable document user viewed',
  SIGNABLE_DOCUMENT_VOIDED: 'signable document voided',
  SIGNABLE_PROVIDER_UPDATED: 'signable provider updated',
  SIGNER_DETAILS_EDITED: 'signer details edited',
  STORAGE_PROVIDER_CONNECTED: 'storage provider connected',
  STORAGE_PROVIDER_DISCONNECTED: 'storage provider disconnected',
  STORAGE_PROVIDER_UPDATED: 'storage provider updated',
  SUBSCRIPTION_ERROR_DISMISSED: 'subscription error dismissed',
  SUBSCRIPTION_PLAN_CLICKED: 'subscription plan clicked',
  SUBSCRIPTION_PLANS_VIEWED: 'subscription plans viewed',
  TEAM_ADDED: 'team added',
  TEAM_EDITED: 'team edited',
  THUMBNAIL_SELECTED: 'thumbnail selected',
  TRIAL_CONVERTED: 'trial converted',
  TRIAL_END_MODAL_VIEWED: 'trial end modal viewed',
  UPGRADE_MODAL_VIEWED: 'upgrade modal viewed',
  USER_INVITED: 'user invited',
  USER_REPLY_POSTED: 'user reply posted',
  USER_VIEW_SET: 'user view set',
  USERS_EXPORTED: 'users exported',
  VISITORS_FILTERED: 'visitors filtered',
  VISITORS_STATS_REMOVED: 'visitor stats removed',
  VISITS_EXPORTED: 'visits exported',
  WELCOME_MESSAGE_OVERLAY_VIEWED: 'welcome message overlay viewed',
  WELCOME_MESSAGE_SAVED: 'DSR - Welcome Message - Saved',
  WELCOME_MESSAGE_MODAL_CLOSED_WITHOUT_SAVE:
    'DSR - Welcome Message - Modal Closed Without Save',
  BUYER_COPILOT_CHAT_QUERY_SENT: 'DSR - Buyer Copilot - Message Sent',
  BUYER_COPILOT_AI_CHAT_REPLY_COPIED: 'DSR - Buyer Copilot - Answer Copied',
  BUYER_COPILOT_AI_CHAT_REPLY_FEEDBACK_SUBMITTED:
    'DSR - Buyer Copilot - Feedback Given',
  BUYER_COPILOT_ANSWER_MENTIONS_CLICKED:
    'DSR - Buyer Copilot - Answer Source Clicked',
  BUYER_COPILOT_OPENED: 'DSR - Buyer Copilot Opened',
  BUYER_COPILOT_LOADED: 'DSR - Buyer Copilot Loaded',
  BUYER_COPILOT_ANSWER_GENERATED: 'DSR - Buyer Copilot Answer Generated',
  BUYER_COPILOT_CHAT_HISTORY_CLEARED:
    'DSR - Buyer Copilot - Chat History Cleared',
  DSR_FOLDER_CREATED: 'DSR - Folder Created',
  DSR_FOLDER_RENAMED: 'DSR - Folder Renamed',
  DSR_FOLDER_DELETED: 'DSR - Folder Deleted',
  DSR_FOLDER_OPENED_ROOM_EDITOR: 'DSR - Folder Opened (Room Editor)',
  DSR_FOLDER_OPENED_ROOM_VISITOR: 'DSR - Folder Opened (Room Visitor)',
  DSR_FOLDER_BREADCRUMB_CLICKED: 'DSR - Folder Breadcrumb Clicked',
};

export const Properties = {
  ACTIVE_USERS: 'active users',
  ADDED_COLLABORATOR: 'added collaborator',
  ADDITIONAL_PROMPT: 'additional prompt',
  ANONYMOUS_VISITOR: 'anonymous visitor',
  ANONYMOUS: 'anonymous',
  ATTRIBUTE: 'attribute',
  AUTHENTICATION: 'authentication',
  AUTO_NUDGE: 'auto nudge',
  AUTOPICK_SECONDARY: 'autopick secondary',
  BANNER_IMAGE: 'banner image',
  BUTTON_TEXT: 'button text',
  CAN_CREATE_AUDIO: 'can create audio',
  CAN_CREATE_DOCUMENT: 'can create document',
  CAN_CREATE_TEXT: 'can create text',
  CAN_CREATE_VIDEO: 'can create video',
  CATEGORY: 'category',
  CLIENT_LOGO: 'client logo',
  COLLABORATOR_NUMBER_CHANGE: 'collaborator number change',
  COLLABORATOR_NUMBER: 'collaborator number',
  COMPANY: 'company',
  COMPANY_NAME: 'company name',
  COMPANY_SELECTION_TYPE: 'company selection type',
  COMPLETED: 'completed',
  CONNECTED: 'connected',
  CONTACT_NUMBER: 'contact number',
  CONTENT_ID: 'content id',
  CONTENT_NUMBER: 'content number',
  CONTENT_TYPE: 'content type',
  COUPON: 'coupon',
  COVER_IMAGE_TYPE: 'cover image type',
  COVER_IMAGE: 'cover image',
  COVER_TYPE: 'cover type',
  CREATED_FROM: 'created from',
  CRM_RESULTS_RETURNED: 'crm results returned',
  CRM_SEARCH: 'crm search',
  CRM: 'crm',
  CUSTOM_HEADLINE_FONT: 'custom headline font',
  CUSTOM_PRIMARY_COLOR: 'custom primary color',
  CUSTOM_QA_ICON: 'custom q&a icon',
  CUSTOM_REGULAR_FONT: 'custom regular font',
  CUSTOM_SECONDARY_COLOR: 'custom secondary color',
  DATE_RANGE: 'date range',
  DEAL_AMOUNT: 'deal amount',
  DEAL_CURRENCY: 'deal currency',
  DEAL_NAME: 'deal name',
  DEAL_OWNER: 'deal owner',
  DEAL_STAGE: 'deal stage',
  DEAL_TYPE: 'deal type',
  DENY_REASON: 'deny reason',
  DISTRIBUTION_METHOD: 'distribution method',
  DOCUMENT_TYPE: 'document type',
  DOMAIN_NAME: 'domain name',
  DOWNLOADABLE: 'downloadable',
  EMAIL_NOTIFICATIONS: 'email notifications',
  EMAIL_PARAMETER: 'email parameter',
  EMAIL: 'email',
  ENABLE_QA: 'enable Q&A',
  ENABLED: 'enabled',
  ENTERED_FROM: 'entered from',
  ERROR_MESSAGE: 'error message',
  EXIT_BUTTON: 'exit button',
  FEATURE: 'feature',
  FILESIZE: 'filesize',
  FILETYPE: 'filetype',
  FILTER_NUMBER: 'filter number',
  FILTER_TYPE: 'filter type',
  FILTER_VALUE: 'filter value',
  FILTERED: 'filtered',
  FILTERS_APPLIED: 'filters applied',
  FREE_TRIAL: 'free trial',
  FROM_CONTENTS: 'from contents',
  FROM_ROOM: 'from room',
  FROM_TEMPLATE: 'from template',
  FUZZY_SEARCH: 'fuzzy match',
  GOOGLE_DRIVE_SYNC: 'google drive sync',
  HAS_BANNER: 'has banner',
  HAS_COMPANY: 'has company',
  HAS_CONTACT_CARD: 'has contact card',
  HAS_CUSTOM_MESSAGE: 'has custom message',
  HAS_DEAL: 'has deal',
  HAS_DESCRIPTION: 'has description',
  HAS_DUE_DATE: 'has due date',
  HAS_EMAIL_VERIFICATION: 'has email verification',
  HAS_ERROR: 'has error',
  HAS_EXPIRATION: 'has expiration',
  HAS_EXPLICIT_INVITE: 'has explicit invite',
  HAS_FIRST_NAME: 'has first name',
  HAS_JOB_TITLE: 'has job title',
  HAS_LAST_NAME: 'has last name',
  HAS_MAP: 'has map',
  HAS_NAME: 'has name',
  HAS_PASSCODE: 'has passcode',
  HAS_REQUIRES_EMAIL: 'has requires email',
  HAS_ROOM_CREATORS: 'has room creators',
  HAS_SIGNABLE_DOCUMENT: 'has signable document',
  HAS_THUMBNAIL: 'has thumbnail',
  HAS_WELCOME_MESSAGE: 'has welcome message',
  HEIGHT: 'height',
  ICON_SOURCE: 'icon source',
  INVITEE_ROLE: 'invitee role',
  IS_ANONYMOUS_EXISTING_CONTACT: 'is anonymous an existing contact',
  IS_CUSTOM_HEADER: 'is custom header',
  IS_MILESTONE: 'is milestone',
  ITEMS_VIEWED: 'items viewed',
  JOB_TITLE: 'job_title',
  LAYOUT: 'layout',
  LOCAL_RESULTS_RETURNED: 'local results returned',
  LOGGED_IN: 'logged in',
  MILESTONE_NUMBER: 'milestone number',
  MINIMUM_DEAL_AMOUNT: 'minimum deal amount',
  MP_COMPANY: '$company',
  MP_EMAIL: '$email',
  MP_FIRST_NAME: '$first_name',
  MP_LAST_NAME: '$last_name',
  MP_NAME: '$name',
  NAME: 'name',
  NUMBER_ASSIGNED_SIGNERS: 'number assigned signers',
  NUMBER_ATTACHMENTS: 'number attachments',
  NUMBER_DOMAINS_SELECTED: 'number domains selected',
  NUMBER_DOMAINS: 'number domains',
  NUMBER_EXISTING_CONTENT: 'number existing content',
  NUMBER_EXISTING_LINKS: 'number existing links',
  NUMBER_FILTERS_SELECTED: 'number filters selected',
  NUMBER_INVITED: 'number invited',
  NUMBER_MENTIONS: 'number mentions',
  NUMBER_OWNERS: 'owners number',
  NUMBER_PEERS: 'number peers',
  NUMBER_PAGES: 'number pages',
  NUMBER_QUESTIONS: 'number questions',
  NUMBER_REPLIES: 'number replies',
  NUMBER_SIGNED: 'number signed',
  NUMBER_TEAMS: 'number teams',
  NUMBER_UNASSIGNED_SIGNERS: 'number unassigned signers',
  NUMBER_USERS: 'number users',
  NUMBER_VALUES: 'number values',
  NUMBER_VISITS: 'number visits',
  OPTION_NUMBER: 'option number',
  ORGANIZATION_ID: 'organization id',
  ORGANIZATION_NAME: 'organization name',
  ORGANIZATION_TYPE: 'company_type',
  OWNER: 'owner',
  PARTNER_SETTINGS: 'partner settings',
  PATH: 'path',
  PDF_VIEWER: 'pdf viewer',
  PERSONAL: 'personal',
  PLAN_FREQUENCY: 'plan frequency',
  PLAN: 'plan',
  PRIMARY_GOAL: 'primary goal',
  PROVIDER: 'provider',
  QUESTION: 'question',
  REASON: 'reason',
  RECORDS: 'records',
  REFERENCE_CATEGORIES: 'reference categories',
  REFERENCE_CATEGORY: 'reference category',
  REFERENCE_NUMBER: 'reference number',
  REFERRAL: 'referral',
  REMINDER_NUMBER: 'reminder number',
  REMINDER_SENT: 'reminders sent',
  REMOVED_BY: 'removed by',
  RESOLUTION_SELECTED: 'resolution selected',
  RESULTS_RETURNED: 'results returned',
  ROLE: 'role',
  ROOM_AUDIENCE: 'room audience',
  ROOM_COUNT: 'room count',
  ROOM_CREATORS: 'room creators',
  ROOM_NAME: 'room name',
  ROOM_TYPE: 'room type',
  ROOMS: 'rooms',
  SALES_ACTION: 'sales action',
  SALES_ACTIONS_NUMBER: 'sales actions number',
  SEARCH_APPLIED: 'search applied',
  SEARCH_PAGE: 'search page',
  SEARCH_QUERY: 'search query',
  SEARCH_RESULT: 'search result',
  SEARCH_RESULTS_PER_PAGE: 'search results per page',
  SEARCH: 'search',
  SECTION_HEADER_NUMBER: 'section header number',
  SECTION_HEADER: 'section header',
  SECTION: 'section',
  SELECTED_SESSION: 'selected session',
  SENT_COPY_TO_SELF: 'sent copy to self',
  SENT_TO_COLLABORATORS: 'sent to collaborators',
  SENT_TO_NON_VISITORS: 'sent to non-visitors',
  SENT_TO_VISITORS: 'sent to visitors',
  SHARED_AVAILABILITY: 'shared availability',
  SIGNABLE_CONNECTION_STATUS: 'connection status',
  SIGNABLE_PROVIDER: 'signable provider',
  SIGNABLE_STATUS: 'signable status',
  SINGLE_USE: 'single use',
  SLACK_NOTIFICATIONS: 'slack notifications',
  SMS_COUNT: 'sms count',
  SORT_BY: 'sort by',
  SOURCE: 'source',
  SPECIFIED_GOAL: 'specified goal',
  SPECIFIED_REFERRAL: 'specified referral',
  STATUS: 'status',
  STEP: 'step',
  STORAGE_PROVIDER: 'storage provider',
  STREAM: 'stream',
  SUBSCRIPTION_STATUS: 'subscription status',
  TASK_NUMBER: 'task number',
  TEAM: 'team',
  TEAMS: 'teams',
  TEMPLATE_NAME: 'template name',
  TEMPLATE_NUMBER: 'template number',
  TEMPLATE_TYPE: 'template type',
  TEMPLATE: 'template',
  TEXT_BOX_NUMBER: 'text box number',
  TEXT_BOX_POSITIONS: 'text box positions',
  TIME_SINCE_SESSION: 'time since session',
  TIME_SINCE_UPLOAD: 'time since upload',
  TOTAL_USERS: 'total users',
  TYPE: 'type',
  UPDATE_SCOPE: 'update scope',
  UPLOADED_RESULTS_RETURNED: 'uploaded results returned',
  URL: 'url',
  USER_ID: 'user id',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_CONTENT: 'utm_content',
  UTM_MEDIUM: 'utm_medium',
  UTM_SOURCE: 'utm_source',
  UTM_TERM: 'utm_term',
  VALUES: 'values',
  VANITY_URL: 'vanity url',
  VENDOR_ID: 'vendor id',
  VENDOR_USER_ID: 'vendor user id',
  VENDOR: 'vendor',
  VERSION: 'version',
  VISIT_NUMBER_SELECTED: 'visit number selected',
  VISITORS: 'visitors',
  WAS_CLONED: 'was cloned',
  WELCOME_MESSAGE_COVER: 'welcome message cover',
  WELCOME_MESSAGE: 'welcome message',
  WIDTH: 'width',
  ZIPY_SESSION_URL: 'zipy session url',
  DATADOG_SESSION_URL: 'datadog session url',
  AUTO_DRAFTED: 'auto drafted',
  OWNER_STATUS: 'owner status',
  ROOMS_CHANGED: 'rooms changed',
  ASSET_ID: 'asset_id',
  ASSET_TYPE: 'asset_type',
  DSR_ACTOR: 'actor',
  DSR_AUTH_REQUIRED: 'auth_required',
  DSR_ENTRY_POINT: 'entry_point',
  DSR_TARGET_ID: 'target_id',
  DSR_TARGET_TYPE: 'target_type',
  ROOM_ID: 'room_id',
  SECTION_ID: 'section_id',
  SECTION_NAME: 'section_name',
  TOGGLED_TO: 'toggled_to',
  DSR_ROOM_TYPE: 'room_type',
  FOLDER_ID: 'folder_id',
  PARENT_FOLDER_ID: 'parent_folder_id',
  FOLDER_DEPTH: 'depth',
};

export const Authentication = {
  EMAIL_PASSWORD: 'email-password',
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
};

export const Referrers = {
  AUTOMATION: {
    TEMPLATE_PICKER: 'template-picker-module',
  },
  ACTION_PLAN: {
    HOME: 'MAP',
    TASK_OWNER: 'MAP Task Owner',
  },
  ACTION_PLAN_TEMPLATES: {
    HOME: 'MAP Templates',
  },
  BULK_UPDATES: {
    CONTENTS: 'Bulk Updates Content Details',
  },
  CHROME_EXTENSION: {
    HOME: 'Chrome Extension',
    GMAIL: 'Chrome Extension - Gmail',
  },
  CRM: {
    INTEGRATIONS: {
      CONNECT: 'CRM Integrations',
      HOME: 'Integrations',
    },
    SELECT_DEAL: 'Select Deal',
  },
  COMPANIES: {
    HOME: 'Companies',
  },
  CONTACTS: {
    HOME: 'Contacts',
  },
  CONTENT: {
    HOME: 'Content',
    LINK_PUBLISHED: 'Link Published',
    MANAGE_LINKS: 'Manage Links',
    PREVIEW: 'Content Preview',
    PROVIDER_IFRAME: 'Provider Iframe',
    REORDER: {
      MAIN: 'Main Button',
      SECTION_HEADER: 'Section Header Tab',
    },
    UPLOAD: 'Upload Content',
  },
  DEALS: {
    HOME: 'Deals',
  },
  DEAL_ROOMS: {
    ACTIVITY: {
      ACTION_PLAN: 'Deal Room - MAP',
      ASK_QUESTION: 'Deal Room - Ask a Question',
      DOWNLOAD_ATTACHMENT: 'Deal Room - Download attachment',
      ENTER: 'Deal Room - Enter',
      MESSAGE_INPUT: 'Deal Room - Conversation Message Input',
      MESSAGE_REPLY: 'Deal Room - Conversation Reply Button',
      REQUEST_CONTACT: 'Deal Room - Request Contact',
      SCHEDULE_CALL: 'Deal Room - Schedule a Call',
    },
    BUYER_COPILOT: 'Buyer Copilot - Contact Name Editor',
    CLONE: 'Clone Deal Room',
    CONTACT_VIEW: 'Deal Room Contact View',
    CONVERSATION_MENTION: 'Conversation Mention',
    CREATE: 'Create Deal Room',
    EDIT: 'Edit Deal Room',
    EMAIL: 'Deal Room Email',
    HOME: 'Deal Rooms',
    MAP_TASK_DISCUSSION_MENTION: 'MAP Task Discussion Mention',
    SHARED_WITH_ME: 'Deal Rooms-Shared with me',
    SMS: 'SMS',
    STATISTICS: 'Deal Room Statistics',
    USER_VIEW: 'Deal Room User View',
    UPDATE_EMAIL: 'Email-Room updated',
    REMINDER_EMAIL: 'Email-Room Reminder',
    SHARED_EMAIL: 'Email - Room Shared',
  },
  INSIGHTS: {
    HOME: 'Insights',
  },
  LIBRARY: {
    CONTENT_SELECTED: 'Library-Content Selected',
    SEARCH: 'Search Results',
    HOME: 'Library',
  },
  NAVIGATION: {
    HOME: 'Navigation',
  },
  PUBLIC_CONTENT: {
    HOME: 'Public Content',
  },
  REQUESTED_REFERENCE: {
    HOME: 'Requested Reference',
  },
  REFERENCE_REQUEST: {
    HOME: 'Reference Request',
  },
  RESET_PASSWORD: {
    HOME: 'Reset Password',
  },
  ROOM_STEP: {
    REORDER: 'Reorder Step',
    REVIEW: 'Review Step',
  },
  ROOM_TEMPLATES: {
    CREATE: 'Create Room Template',
    EDIT: 'Edit Room Template',
    HOME: 'Room Templates',
  },
  ROOM: {
    ADD_TO_ROOM: 'Add To Room',
    STATISTICS: {
      CONTENT_SESSION: 'Room Statistics - Content Session',
      HOME: 'Room Statistics',
      SESSION_DROPDOWN: 'Room Statistics - Session Dropdown',
    },
    EMAIL: 'Room Statistics Email',
  },
  SETTINGS: {
    REFERENCE_CATEGORIES: 'Settings - Reference Categories',
    ROOM_OPTIONS: 'Settings - Room Options',
    INTEGRATIONS: 'Settings - Integrations',
    PERSONAL: {
      INTEGRATIONS: 'Personal Integrations',
    },
    SUBSCRIPTION: 'Settings - Subscription',
  },
  SHARED_LINKS: {
    DETAILS: 'Shared Link Overview',
    HOME: 'Shared Links',
    STATISTICS: 'Shared Link Statistics',
  },
  SIGNABLES: {
    CHANGE_SIGNERS: 'Change signers',
    HOME: 'Signables',
    SELECT_TEMPLATE: 'Select template',
  },
  SIGN_IN: {
    HOME: 'Sign In',
  },
  SIGN_UP: {
    HOME: 'Sign Up',
    CREATE_ORGANIZATION: 'Create Organization',
    LANDING_PAGE:
      'https://www.enableus.com/pricing?utm_source=EnableUsPlatform&utm_medium=Link',
  },
  SUBSCRIPTION: {
    TRIAL_ENDED: 'Subscription - Trial Ended',
  },
  TEMPLATES: {
    HOME: 'Templates',
    ROOM_TEMPLATES: 'Room Templates',
  },
  UPGRADE_MODAL: {
    MAIN: 'Upgrade Modal',
  },
};
